import { AiOutlineInstagram } from 'react-icons/ai';
import { HiOutlineMail } from 'react-icons/hi';
import { AiFillGithub } from 'react-icons/ai';
import { AiFillLinkedin } from 'react-icons/ai';

const data = [
  { id: 1, link: 'https://www.instagram.com/lengynnn/', label: 'Instagram', icon: <AiOutlineInstagram /> },
  { id: 2, link: 'mailto:nguyenlenguyen.1042006@gmail.com', label: 'Email', icon: <HiOutlineMail /> },
  { id: 3, link: 'https://github.com/kainguyen104', label: 'GitHub', icon: <AiFillGithub /> },
  { id: 4, link: 'https://www.linkedin.com/in/kainguyen104/', label: 'LinkedIn', icon: <AiFillLinkedin /> }
];

export default data;
